<template>
  <div id="modal-menu">
    <div class="modal-content">
      <button type="button" class="close close-left" data-dismiss="modal" aria-label="Close" @click="$emit('close'), $root.$emit('triggerLoadDealDetail', id)">
        <span aria-hidden="true">×</span></button>
      <form id="form-add-menu" method="post" action="#">
        <div class="modal-body display-flex flex-column">
          <div class="modal-head pb-20">
            <div class="image-cover sides">
              <img v-if="menu.image"
                   v-bind:src="(menu.image.desktop_detail) ? menu.image.desktop_detail : $const.IMG_PIZZA_DEFAULT"
                   class="desktop-only">
              <img v-if="menu.image"
                   v-bind:src="lodash.get(menu, 'image.desktop_thumbnail', null) || $const.IMG_PIZZA_DEFAULT"
                   class="mobile-only">
            </div>
            <h1 class="t22 fw600 title-name">{{ menu.name }}</h1>
            <div class="flex flex-row flex-wrap pt-10 pb-10">
              <div v-for="(img, indeximg) in menu.menu_attributes" :key="indeximg" class="pl-10">
                <img v-if="img.image && img.image.icon" alt="" v-bind:src="img.image.icon"  width="30" class="pl-5" />
                {{img.name}}
              </div>
            </div>
            <!--<p v-if="menu.marketing_description"-->
              <!--class="t13 fw300 pr10 pt10 text-black" style="">-->
              <!--<nl2br tag="p" :text="menu.marketing_description"/>-->
            <!--</p>-->
            <p v-if="menu.main_description"
               class="t13 fw300 pr10 pt10 text-black" style="">
              <nl2br tag="p" :text="menu.main_description"/>
            </p>
            <div role="button" @click="showAccordionTC = !showAccordionTC" v-if="menu.t_and_c">
              <h6 class="panel-title t14 fw600">
                <i class="fa fa-caret-down" v-if="showAccordionTC"></i>
                <i class="fa fa-caret-up" v-if="!showAccordionTC"></i>
                <span class="pl-5">{{$t('t_and_c')}}</span>
              </h6>
            </div>
            <collapse v-model="showAccordionTC" v-if="menu.t_and_c">
              <div class="menu-description " style="color:#d9b084">
                <nl2br tag="p" :text="menu.t_and_c"/>
              </div>
            </collapse>
            <span class="add-toppings-str pl-10" v-if="addExtraTopping.length > 0">
              <span class="text-green"><strong>{{$t('cart.add')}}: {{convertString(addExtraTopping.map(f=>f.name).join(', '))}} </strong></span>
              <span class="content text-capitalize"></span>
              <br>
            </span>
            <span class="remove-toppings-str pl-10" v-if="removeYourTopping.length > 0">
              <span class="text-orange"><strong>{{$t('cart.remove')}}: {{convertString(removeYourTopping.map(f=>f.name).join(', '))}}</strong></span>
              <span class="content text-capitalize"></span>
            </span>
          </div>
          <div class="flex1auto selector-container " style="max-height: calc(100vh - 500px);">
            <!-- ############################## Choose size & crust ########################## -->

              <div class="box-select-variant-addon"
                   v-if="(!choosedFirst.name || !choosedFirst.second_layers || !choosedFirst.second_layers.length) && !choosedName">
                <p class="fw600 t15 mb15 text-black bg-grey-lightest md:bg-transparent p10 "
                v-if="menu && menu.first_layers && menu.first_layers.length > 0 &&
                 menu.first_layers[0].second_layers && menu.first_layers[0].second_layers.length">
                  {{$t('menu.select_size_crust')}}</p>
                <div v-for="(item, fin) in menu.first_layers" :key="fin">

                  <!--Add-on-->
                  <div v-if="!item.second_layers || !item.second_layers.length"
                    class="no-second t15 fw600 heading-line-right mt10 mb10 text-black p10 bg-white variant-addon-item md:bg-transparent" v-on:click="chooseSize(item)">
                    <label class="flex1 text-black fw400">
                      <span class="radio variant-addon-item-size text-black" :class="item.checked ? 'checked' : '' "></span>
                      <i class="pull-left"></i>
                      <span>{{item.name}}</span>
                    </label>
                    <div class="fw600 text-right pl10 pr10 flex-center">{{$const.CURRENCY}} {{ formatNum(item.price) }}</div>
                  </div>
                  <!--./ Add-on-->

                  <!--Size's label-->
                  <div v-else
                       class=" group-name t15 fw600 heading-line-right mt10 mb10 text-black p10 bg-white md:bg-transparent">

                    <label v-show="menu.first_layers.length > 1 && (!item.second_layers || !item.second_layers.length)"></label>

                    <span>{{item.name}}</span>
                  </div>
                  <!--./Size's label-->

                  <div v-for="(subitem, sin) in item.second_layers" :key="sin"
                       class="variant-addon-item option display-flex t15 p10 text-black bg-grey-lightestest md:bg-transparent active"
                       @click="choosetopping(item,subitem)">
                    <div class="flex1 display-flex items-center justify-start text-black fw400">
                      <div>
                        <img v-bind:src="lodash.get(subitem, 'image.desktop_thumbnail', null) || $const.IMG_CRUST_DEFAULT"
                             class="option---icon">
                      </div>
                      <div class="pl-10 option---content ">
                        <div>{{subitem.name}}</div>
                        <div class="option__long-description t13 fw400"></div>
                      </div>
                    </div>
                    <div class="fw600 text-right pl10 pr10 flex-center">{{$const.CURRENCY}}
                      {{ formatNumDisplay(sumNum(menu.price, item.price, subitem.price)) }}
                    </div>
                  </div>
                </div>
              </div>
            <!-- ################################################################################### -->
            <!-- ############################ Topping ###################################### -->
            <div class="p10 box-topping-contain"
                 v-if="changeCrustAndSize()">

              <div class="variant-addon-choosen p10">
                <div class="display-flex t15">
                  <span class="flex1 name fw400  text-black">{{convertString(choosedName)}} </span>
                  <!-- <span class="flex2 price fw600  cl-525252 mr10 hidden">RM 5.30</span> -->

                  <a @click="changeSize" class="cursor-pointer cl-78838c border-b t13">Change</a>
                </div>
                <hr>
              </div>
              <div class="menu-toppings  ">
                <div class="topping-header cheese text-black" style="" v-if="showExtra">{{$t('change_cheese')}}</div>
                <div class="extra-cheese option bg-grey-lightestest md:bg-transparent"
                     v-bind:class="{'opacity-3':checkDisableExtra(topping.uuid)}" style=""
                     v-for="(topping) in extraTopping" :key="genUniqueKey(topping)" v-if="topping.special == '1'">
                  <div class="xs-mt-20">
                    <div class="extra-cheese-option" style="">
                      <label class="xs-items-center xs-px-10 rounded label-radio" :for="topping.uuid">
                        <input class="xs-block rounded xs-p-5 radio ExtraCheese " :id="topping.uuid"
                               name="ExtraCheese" :value="topping" v-model="choosedCheese" type="checkbox"
                               :disabled="checkDisableExtra(topping.uuid)">
                        <i class="pull-left xs-my-15"></i>
                        <span class="xs-mr-auto typo-l5 xs-items-center xs-py-15">
                                    <i class="xs-hide md-block xs-mr-10"></i>
                                    <span class="fw400 text-black t15">{{topping.name}}</span>
                                </span>
                        <span class="pull-right extra-cheese-price t15 fw600 cl-525252">+ {{$const.CURRENCY}} {{formatNumDisplay(getPriceTopping(topping.prices))}} </span>
                      </label>
                    </div>
                    <div class="xs-mb-10"></div>
                  </div>
                </div>

                <div class="topping-header" style=""
                     v-if="yourTopping && yourTopping.length > 0 "
                     @click="showToppingMinus = !showToppingMinus"
                     :class="{active: showToppingMinus}">
                  {{$t('your_toppings')}}
                  <i data-v-38def44e="" class="fa fa-caret-down"></i>
                </div>
                <collapse v-model="showToppingMinus">
                  <div class="your-toppings text-black" style="" v-if="yourTopping.length > 0">
                    <transition-group name="fade" v-on:before-leave="beforeLeaveTopping"
                                      v-on:after-leave="afterLeaveTopping">
                      <div class="your-toppings-item display-flex t15 p10 cursor-pointer option visible" style=""
                           v-for="(topping,index) in yourTopping" :key="genUniqueKey(topping)"
                           @click="changeTopping(topping,1,index)">
                        <div class="flex1 fw400">
                          <img v-bind:src="lodash.get(topping, 'image.desktop_thumbnail', null) || $const.IMG_CRUST_DEFAULT" width="24" height="2">
                          <span class="pl-10">{{convertString(topping.name)}}</span>
                        </div>
                        <div class=" text-right pl10 pr10 topping-price fw600 cl-525252" v-if="!topping.default">+
                          {{$const.CURRENCY}} {{formatNumDisplay(getPriceTopping(topping.prices))}}
                        </div>
                        <div class="bold text-right pl10 pr10">
                          <img src="https://static.phdvasia.com/kw/icons/remove.svg" class="cursor-pointer"
                               alt="remove">
                        </div>
                      </div>
                    </transition-group>
                  </div>
                </collapse>
                <div class="topping-header" style=""
                     v-if="extraTopping && extraTopping.length > 0"
                     @click="showToppingPlus = !showToppingPlus"
                     :class="{active: showToppingPlus}">
                  {{$t('add_toppings')}}
                  <i data-v-38def44e="" class="fa fa-caret-down"></i>
                </div>
                <collapse v-model="showToppingPlus">
                  <div class="add-toppings text-black" style="" v-if="extraTopping.length > 0">
                    <transition-group name="fade">
                      <div v-for="(extopping,index) in extraTopping" :key="genUniqueKey(extopping)"
                           v-if="extopping.special != '1'"
                           class="add-toppings-item display-flex t15 p10 cursor-pointer option bg-grey-lightestest md:bg-transparent"
                           v-bind:class="{'disable': extopping.isDisable }"
                           @click="changeTopping(extopping,2, index)">
                        <div class="flex1 fw400 ">
                          <img v-bind:src="lodash.get(extopping, 'image.desktop_thumbnail', null) || $const.IMG_CRUST_DEFAULT" width="24" height="24">
                          <span class="pl-10">{{convertString(extopping.name)}}</span>
                        </div>
                        <div class="text-right pl10 pr10 topping-price fw600 cl-525252" style=""
                             v-if="!extopping.default">+ {{$const.CURRENCY}}
                          {{formatNumDisplay(getPriceTopping(extopping.prices))}}
                        </div>
                        <div class="bold text-right pl10 pr10">
                            <span class="add-icon mr-0 ml-5 fa-plus-icon ">
                                <i class="add-icon__v"></i>
                                <i class="add-icon__h"></i>
                            </span>
                          <img src="https://static.phdvasia.com/kw/icons/remove.svg"
                               class="cursor-pointer fa-remove-image" alt="remove" style="display: none">
                        </div>
                      </div>
                    </transition-group>
                  </div>
                </collapse>
              </div>
            </div>
            <div v-else class="t15 fw600 mt10 mb10 text-black p10 bg-white md:bg-transparent">
              <span>{{convertString(choosedName)}} </span>
            </div>
            <!-- ############################################################################ -->
          </div>
          <div class="modal-action">
            <button type="button"
                    class="btn btn-lg btn-success full  js-action-btn-add"
                    v-bind:class="{disabled : disableAdd}"
                    @click="AddToBasket()">
              {{$t('add_to_my_basket')}}
              <span>{{$const.CURRENCY}}
                <span class="total-price">
                  {{ formatNumDisplay(totalPrice) }}
                </span>
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ['menu', 'sizecrust', 'extracheese', 'cGroup', 'id', 'comboUUID', 'comboName', 'isMultiple'],
  mounted() {
    let autoChoose = false
    if(this.menu && this.menu.first_layers && this.menu.first_layers.length == 1){
      if(!this.menu.first_layers[0].second_layers || !this.menu.first_layers[0].second_layers.length){
         this.chooseSize(this.menu.first_layers[0])
        autoChoose = true
      }
      else if(this.menu.first_layers[0].second_layers && this.menu.first_layers[0].second_layers.length == 1){
         this.choosetopping(this.menu.first_layers[0], this.menu.first_layers[0].second_layers[0])
        autoChoose = true
      }
    }

    if(this.menu){
      this.menu.first_layers.map((item)=> {
        return item.checked = false
      })
    }

    this.getTopping()
    //this.resizePopup()
    this.updateTotalPrice()

    if(autoChoose){
      this.disableAdd = false
      //this.$emit('close')
    }
    let _menu = this.lodash.cloneDeep(this.menu)
    _menu.isMultiple = this.isMultiple
    this.eventTrackingProductDetail(this, _menu, this.$const.CARD_ITEM_TYPE.SINGLE, 'product-list', false, 'deal', this.comboName)
  },
  watch: {
    choosedCheese(val) {
      if(val && val.length){
        this.updateTotalPrice()
        if (parseInt(this.addExtraTopping.length) + parseInt(val.length) >= this.maxExtra) {
          this.showAllExtraTopping(true)
        } else {
          this.showAllExtraTopping(false)
        }
      }

    }
  },
  data: function () {
    return {
      showAccordionTC: false,
      choosedName: '',
      defaultsTopping: [],
      defaultsextraTopping: [],
      yourTopping: [],
      extraTopping: [],
      choosedFirst: {},
      isShowTopping: false,
      removeYourTopping: [],
      addExtraTopping: [],
      totalPrice: 0,
      totalExtraTopping: 0,
      transitionLeave: true,
      choosedCheese: [],
      gotCheese: {'status': 'N', 'price': 0},
      maxExtra: this.menu.extraToppingMax || this.$const.MAX_TOPPING,
      choosedSecond: {},
      disableAdd: false,
      showExtra: false,
      showToppingMinus: false,
      showToppingPlus: false,
    }
  },
  methods: {
    changeCrustAndSize () {
      return this.choosedFirst && this.choosedFirst.name && this.choosedName && ((this.menu.first_layers && this.menu.first_layers.length > 1)
      || (this.menu.first_layers && this.menu.first_layers.length == 1) && (this.menu.first_layers[0].second_layers && this.menu.first_layers[0].second_layers.length >0))
    },
    checkDisableExtra(uuid) {
      let exist = false
      for (let i in this.choosedCheese) {
        if (uuid == this.choosedCheese[i].uuid) {
          exist = true
        }
      }
      if (!exist && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
        return true
      }

      if (exist && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) < this.maxExtra) {
        return false
      }

      return false
    },
    /**
     * resize height modal popup
     * */
    resizePopup() {
      let headH = this.$el.querySelector('.modal-head').scrollHeight + this.$el.querySelector('.modal-action').scrollHeight
      if (window.innerWidth > 768) {
        headH = 350
      } else {
        headH -= 10
      }
      let maxH = window.innerHeight - headH
      this.$el.querySelector('.selector-container').style['max-height'] = maxH + 'px'
    },
    /**
     * Trigger before leave topping event
     */
    beforeLeaveTopping(el) {
      this.transitionLeave = false
    },
    /**
     * Trigger after leave topping event
     */
    afterLeaveTopping(el) {
      this.transitionLeave = true
    },
    /**
     * Chosen first layer - size
     */
    chooseSize(first) {
      this.choosedFirst = this.lodash.cloneDeep(first)
      this.choosedSecond = {}
      this.choosedName = this.choosedFirst.name
      this.updateTotalPrice()
      this.disableAdd = false

      this.menu.first_layers.map((item) => {
        if (item.id == first.id) {
          item.checked = true
        } else {
          item.checked = false
        }
      })

      /*let dataMenu = JSON.parse(JSON.stringify(this.menu))
      dataMenu.first_layers = []
      dataMenu.first_layers.push(first)
      if (first != null && !this.empty(first)) {
        dataMenu.first_layers[0].second_layers = []
      }
      dataMenu.price = this.totalPrice*/
      let product = this.lodash.cloneDeep(this.menu)
      let choosedFirst = this.lodash.cloneDeep(first)

      product.first_layers = []
      product.first_layers.push(choosedFirst)
      product.price = this.totalPrice

      if (first != null && !this.empty(first)) {
        product.first_layers[0].second_layers = []
      }
      let variantUUid = ''
      if (!this.empty(choosedFirst) && choosedFirst.uuid != '') {
        variantUUid += choosedFirst.uuid
      }
      let proClick = this._.cloneDeep(this.menu)
      proClick.variant_uuid = variantUUid
      this.evenTrackingProductClick(this, proClick, 'product-selection-from-variant-list')
      product.isMultiple = this.isMultiple
      this.eventTrackingProductDetail(this, product, this.$const.CARD_ITEM_TYPE.SINGLE, 'product-details', false, 'deal', this.comboName)
      this.eventTrackingProductView(product, variantUUid)
    },
    /**
     * Chosen first and second layer
     */
    choosetopping(first, second) {
      this.choosedFirst = first
      this.choosedSecond = second
      this.choosedName = first.name + ' ' + second.name
      this.$set(this.gotCheese, 'status', this.menu.extraCheese)
      this.$set(this.gotCheese, 'price', this.getCheese(first.name))
      this.disableAdd = false
      this.updateTotalPrice()
      /*let dataMenu = JSON.parse(JSON.stringify(this.menu))
      dataMenu.first_layers = []
      dataMenu.first_layers.push(first)
      if (first != null && !this.empty(first)) {
        dataMenu.first_layers[0].second_layers = [second]
      }
      dataMenu.price = this.totalPrice*/
      let product = this.lodash.cloneDeep(this.menu)
      let choosedFirst = this.lodash.cloneDeep(first)
      let choosedSecond = this.lodash.cloneDeep(second)

      product.first_layers = []
      product.first_layers.push(choosedFirst)
      product.price = this.totalPrice

      if (first != null && !this.empty(first)) {
        product.first_layers[0].second_layers = [choosedSecond]
      }
      let variantUUid = ''
      if (!this.empty(choosedFirst) && choosedFirst.uuid != '') {
        variantUUid = choosedFirst.uuid
      }
      if (!this.empty(choosedSecond) && choosedSecond.uuid != '') {
        variantUUid += '-' + choosedSecond.uuid
      }
      let proClick = this._.cloneDeep(this.menu)
      proClick.variant_uuid = variantUUid
      this.evenTrackingProductClick(this, proClick, 'product-selection-from-variant-list')
      product.isMultiple = this.isMultiple
      this.eventTrackingProductDetail(this, product, this.$const.CARD_ITEM_TYPE.SINGLE, 'product-details', false, 'deal', this.comboName)
      this.eventTrackingProductView(product, variantUUid)
    },
    /**
     * Get cheese price belong size pizza
     * */
    getCheese(size) {
      let price = 0
      for (let cheese in this.extracheese) {
        if (this.extracheese[cheese].Size == this.convertString(size)) {
          price = this.extracheese[cheese].Price
        }
      }
      return price
    },
    /**
     * Get topping price
     * */
    getPriceTopping(topping) {
      let price = 0
      if (topping) {
        price = topping[this.choosedFirst.sku] ? topping[this.choosedFirst.sku] : 0
      } else {
        price = 0
      }

      return price
    },
    /**
     * Reset item choiced
     * */
    resetDataItem() {
      this.choosedFirst = {}
      this.choosedName = ''
      this.totalPrice = 0
      this.removeYourTopping = []
      this.addExtraTopping = []
      this.yourTopping = JSON.parse(JSON.stringify(this.defaultsTopping))
      this.extraTopping = JSON.parse(JSON.stringify(this.defaultsextraTopping))
      this.totalExtraTopping = 0
      this.choosedCheese = []
    },
    /**
     * reset first and second layer
     * */
    changeSize() {
      this.resetDataItem()
      this.disableAdd = true
      this.totalPrice = ''
    },
    /**
     * Slice topping
     * type: 1: your topping, 2 remove your topping, 3 add topping (default)
     * */
    sliceTopping(topping, type) {
      if (type == 1) {
        for (let y in this.yourTopping) {
          if (this.yourTopping[y].id == topping.id) {
            this.yourTopping.splice(y, 1)
            break
          }
        }
      } else if (type == 2) {
        for (let y in this.removeYourTopping) {
          if (this.removeYourTopping[y].id == topping.id) {
            this.removeYourTopping.splice(y, 1)
            break
          }
        }
      } else {
        for (let y in this.addExtraTopping) {
          if (this.addExtraTopping[y].id == topping.id) {
            this.addExtraTopping.splice(y, 1)
            break
          }
        }
      }
    },
    /**
     * change your topping
     * type: 1: remove topping, 2 add topping
     * */
    changeTopping(topping, type, index) {
      let newTopping = JSON.parse(JSON.stringify(topping))
      if (this.transitionLeave) {
        if (type == 1) {
          this.eventTrackingVariantUnSelect({item: this.menu, topping: topping, first: this.choosedFirst})
          this.yourTopping.splice(index, 1)
          /*let hasTopping = false
          for (let e in this.extraTopping) {
            if (this.extraTopping[e].id == topping.id) {
              hasTopping = true
              break
            }
          }
          if (!hasTopping) {
            this.extraTopping.unshift(topping)
          }*/
          if (!topping.default || (topping.default && !this.checkToppingType(topping, 2))) {
            this.sliceTopping(topping, 3)
            this.updateTotalPrice()
          } else {
            this.removeYourTopping.push(topping)
            this.extraTopping.unshift(newTopping)
          }
          this.updateExtra({topping: topping, type: type})
          this.checkDisableTopping(topping, type)
        } else if (type == 2) { // add them extra
          if (!topping.isDisable) {
            if (topping.default) {
              this.extraTopping = this.extraTopping.filter(function (value, index, arr) {
                return value.id != topping.id
              })
            }
            this.eventTrackingVariantSelect({item: this.menu, topping: topping, first: this.choosedFirst})
            newTopping.default = this.checkToppingType(newTopping, 2)
            if (!newTopping.default) {
              this.addExtraTopping.push(newTopping)
              this.updateTotalPrice()
            } else {
              this.sliceTopping(topping, 2)
            }

            if(newTopping.default){
              this.yourTopping.push(newTopping)
            }else{
              this.yourTopping.unshift(newTopping)
            }

            this.updateExtra({topping: newTopping, type: type})
            this.checkDisableTopping(newTopping, type)
          }
        }

        this.setActiveToppingList(this.extraTopping, this.yourTopping, this.addExtraTopping);
      }
    },
    /**
     * update total price
     * */
    updateTotalPrice() {
      this.totalExtraTopping = 0
      for (let topping in this.addExtraTopping) {
        this.totalExtraTopping += parseFloat(this.getPriceTopping(this.addExtraTopping[topping].prices))
      }
      this.totalPrice = this.menu.price > 0 ? parseFloat(this.menu.price) : 0
      this.totalPrice += parseFloat(this.totalExtraTopping)
      if (typeof this.choosedFirst.price !== 'undefined') {
        this.totalPrice = this.sumNumWithoutFormat(this.choosedFirst.price, this.totalPrice)
      }
      if (typeof this.choosedSecond.price !== 'undefined') {
        this.totalPrice = this.sumNumWithoutFormat(this.choosedSecond.price, this.totalPrice)
      }
      let extraPrice = 0
      for (let i in this.choosedCheese) {
        extraPrice += parseFloat(this.getPriceTopping(this.choosedCheese[i].prices))
      }
      this.totalPrice += parseFloat(extraPrice)
    },
    /**
     * set your and extra toppings
     * */
    getTopping() {
      //Checking to disable add button
      if (this.menu.first_layers.length > 0) {
        this.disableAdd = true
      }

      let data = JSON.parse(JSON.stringify(this.menu.toppings.default))
      let extraData = JSON.parse(JSON.stringify(this.menu.toppings.extra))
      for (let topping in data) {
        data[topping].default = true
        data[topping].isDisable = false
      }
      this.yourTopping = data !== null ? data : []
      this.extraTopping = extraData !== null ? extraData : []
      this.showExtra = false
      for (let topping in this.extraTopping) {
        this.extraTopping[topping].default = false
        if (this.maxExtra == 0) {
          this.extraTopping[topping].isDisable = true
        } else {
          this.extraTopping[topping].isDisable = false
        }
        if (this.extraTopping[topping].special == '1') {
          this.showExtra = true
        }
      }
      this.defaultsTopping = JSON.parse(JSON.stringify(this.yourTopping))
      this.defaultsextraTopping = JSON.parse(JSON.stringify(this.extraTopping))
    },
    /**
     * check topping is extra or default
     * type: 1 isExtra, 2 Default
     * */
    checkToppingType(topping, type) {
      let i = 0
      for (let t in this.defaultsTopping) {
        if (this.defaultsTopping[t].id == topping.id) {
          i++
        }
      }
      if (i == 0) {
        return type == 1
      }
      i = 0
      for (let t in this.yourTopping) {
        if (this.yourTopping[t].id == topping.id) {
          i++
        }
      }
      if (type == 1) {
        return i > 0
      }
      return i == 0
    },
    /**
     * re-update extra and default toppings
     * type: 1 remove topping, 2 add topping
     * */
    updateExtra(topping, type) {
      for (var t in this.extraTopping) {
        if (this.extraTopping[t].id == topping.id) {
          if (type == 1) {
            if (topping.default && this.yourTopping.length > 0) {
              this.extraTopping[t].default = true
              for (var y in this.yourTopping) {
                if (this.yourTopping[y].id == topping.id) {
                  this.yourTopping[y].default = true
                  this.extraTopping[t].default = false
                  break
                }
              }
            } else {
              this.extraTopping[t].default = topping.default
            }
          } else {
            this.extraTopping[t].default = false
          }
        }
      }
    },
    /**
     * Check to show/hide extra topping
     * type: 1 remove topping, 2 add topping (default)
     * */
    checkDisableTopping(topping, type) {
      if (parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
        this.updateDisable()
      } else {
        if (topping.default) {
          if (type == 1) {
            if (this.removeYourTopping.length > 0 && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) >= this.maxExtra) {
              for (let t in this.extraTopping) {
                for (let rm in this.removeYourTopping) {
                  if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                    this.extraTopping[t].isDisable = false
                    break
                  }
                }
              }
            } else {
              this.showAllExtraTopping(false)
            }
          } else if (type == 2) {
            for (let t in this.extraTopping) {
              for (let rm in this.removeYourTopping) {
                if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                  this.extraTopping[t].isDisable = false
                  break
                }
              }
            }
          }
        } else {
          if (type == 1) {
            this.showAllExtraTopping(false)
          } else {
            let disable = true
            if (this.removeYourTopping.length > 0 && parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) < this.maxExtra) {
              for (let t in this.extraTopping) {
                for (let rm in this.removeYourTopping) {
                  if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
                    disable = false
                    break
                  } else {
                    if (!this.extraTopping[t].default) {
                      disable = false
                    }
                  }
                  this.extraTopping[t].isDisable = disable
                }
              }
            } else {
              if (parseInt(this.addExtraTopping.length) + parseInt(this.choosedCheese.length) == this.maxExtra) {
                for (let t in this.extraTopping) {
                  this.extraTopping[t].isDisable = true
                }
              }
            }
          }
        }
      }
    },
    /**
     * Checking to show/hide extra topping
     * */
    updateDisable() {
      for (let t in this.extraTopping) {
        let disable = true
        if (this.removeYourTopping.length > 0) {
          for (let rm in this.removeYourTopping) {
            if (this.extraTopping[t].id == this.removeYourTopping[rm].id) {
              disable = false
              break
            }
          }
        } else {
          if (!this.extraTopping[t].default) {
            disable = true
          }
        }
        this.extraTopping[t].isDisable = disable
      }
    },
    /**
     * Show extra topping
     * */
    showAllExtraTopping(s) {
      for (let t in this.extraTopping) {
        this.extraTopping[t].isDisable = s
      }
    },
    AddToBasket() {
      if (!this.disableAdd) {
        for (var cb in this.cGroup) {
          if (this.cGroup[cb].GroupId == this.id) {
            let price = this.choosedFirst.price && this.choosedFirst.price > 0 ? this.choosedFirst.price : 0
            price += this.choosedSecond.price && this.choosedSecond.price > 0 ? this.choosedSecond.price : 0
            this.cGroup[cb].item.name = this.menu.name + ' ' + (this.choosedFirst.name != undefined ? this.choosedFirst.name : '')
            this.cGroup[cb].item.id = this.menu.id
            this.cGroup[cb].item.choosedSecond = this.choosedSecond
            this.cGroup[cb].item.choosedFirst = this.choosedFirst
            this.cGroup[cb].item.price = price
            this.cGroup[cb].item.totalPrice = this.totalPrice
            this.cGroup[cb].item.Default = this.defaultsTopping
            this.cGroup[cb].item.Remove = this.removeYourTopping
            let newExtraTopping = this.lodash.union(this.addExtraTopping, this.choosedCheese)
            this.cGroup[cb].item.Add = newExtraTopping
            this.cGroup[cb].item.uuid = this.menu.uuid
            if (this.choosedCheese) {
              this.cGroup[cb].item.CheesePrice = this.gotCheese.price
            } else {
              this.cGroup[cb].item.CheesePrice = 0
            }
            this.cGroup[cb].item.image = (this.menu.image && this.menu.image.desktop_detail) ? this.menu.image.desktop_detail : ''
          }
        }
        let pro = {
          item: this.menu,
          id: this.menu.uuid,
          uuid: this.menu.uuid,
          combo_uuid: this.comboUUID,
          name: this.menu.name,
          price: this.totalPrice,
          first: this.choosedFirst || {},
          second: this.choosedSecond || {}
        }
        /*let productclickUUid = this.menu.uuid
        if (!this.empty(this.choosedFirst) && this.choosedFirst.uuid != '') {
          productclickUUid += '-' + this.choosedFirst.uuid
        }
        if (!this.empty(this.choosedSecond) && this.choosedSecond.uuid != '') {
          productclickUUid += '-' + this.choosedSecond.uuid
        }*/

        // this.evenTrackingProductClick(this, {uuid: productclickUUid}, 'add-to-deal')
        this.eventTrackingAddToDeal(this, pro)
        this.$root.$emit('responseComboGroup', this.cGroup, this.id)
        this.$emit('close')
      }
    }
  }
}
</script>
<style scoped>
  .title-name {
    font-family: SharpSansBold, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }
  .group-name{
    font-family: SharpSansSemiBold, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalCombo.vue